import { Button, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconUserQuestion } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useNotifications } from '../hooks/useNotifications';
import { bannerDetail, bannerHeadline } from '../lib/notifications';
import { profilePath } from '../lib/profileNav';

// Shown to admins on the landing page while anyone is waiting; it goes away when the queue is empty.
export function WaitingRequestsBanner() {
  const { state } = useNotifications();
  const waiting = state?.waiting ?? [];
  if (waiting.length === 0) return null;

  return (
    <Group
      role="status" gap={14} px={18} py={14} wrap="nowrap" align="center"
      style={{ border: '1px solid var(--accent-text)', borderRadius: 12, background: 'var(--bg-surface)' }}
    >
      <ThemeIcon radius="xl" size={34} variant="light" color="var(--accent-text)">
        <IconUserQuestion size={17} stroke={2} />
      </ThemeIcon>
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
        <Text fz="sm" fw={700}>{bannerHeadline(waiting.length)}</Text>
        <Text fz="sm" c="var(--text-muted)">{bannerDetail(waiting)}</Text>
      </Stack>
      <Button component={Link} to={profilePath('requests')} size="sm">Review requests</Button>
    </Group>
  );
}
